<script>
import UserService from "@/helpers/APIService/user.service";
import hkService from "@/helpers/APIService/hk.service";
import errorHandler from "../helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import DatePicker from "vue2-datepicker";
import Middleware from "@/helpers/middlewares";

export default {
  name: "staff_shift",
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "saveAndAddNew", "cancelSubmit"],
  components: {
    DatePicker,
  },
  data() {
    return {
      staffs: [],
      selectedDate: this.currentProps.date,
      formStaffs: [],
      isBtnLoading: false,
      staffName: "",
      errorMessage: "",
      errorStatusCode: "",
      isSaveAndAddNew: false,
      selectAllStaff: false,
    };
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getStaffList();
  },
  methods: {
    // Method is use for get all staffs
    async getStaffList() {
      UserService.getStaffList()
        .then((staff) => {
          this.staffs = staff;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for add and remove staff
    addStaff(staff) {
      if (staff == "selectAllStaff") {
        this.formStaffs = [];
        this.selectAllStaff = !this.selectAllStaff;
        if (this.selectAllStaff) {
          this.formStaffs = this.staffs;
        }
      } else {
        if (this.formStaffs.includes(staff.id)) {
          this.formStaffs.unshift(staff);
        }
      }
    },
    // Method is use to add new staff shift
    handleSubmit() {
      this.isBtnLoading = true;
      let tempArray = [];
      this.formStaffs.map((item) => {
        tempArray.push({
          hotel: this.hotel.id,
          staff_user: item.id,
          shift_date: this.selectedDate,
        });
      });
      if (this.formStaffs.length === 0) {
        Middleware.notification("Please select a staff !!", "danger", 3000);
        this.isBtnLoading = false;
      } else {
        hkService
          .createStaffShift(tempArray)
          .then((response) => {
            if (!this.isSaveAndAddNew) {
              this.$emit("submitted", response);
            } else {
              this.$emit("saveAndAddNew", response);
              this.formStaffs = [];
            }
            Middleware.notification(
              "Shift added successfully !!",
              "success",
              3000
            );
            this.isBtnLoading = false;
          })
          .catch((error) => {
            errorHandler(error);
            this.isBtnLoading = false;
            this.errorStatusCode = error.response.status;
            this.createError = true;
            this.errorMessage = error.response.data[0].non_field_errors[0];
          });
      }
    },
    // Method is use to add new staff shift continue
    saveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.handleSubmit();
    },
    // Method is use for cancel the new staff shift
    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },
  },
};
</script>

<template>
  <div>
    <div class="row text-dark" v-if="errorStatusCode === ''">
      <div class="col-md-12">
        <h4 class="mb-0">Add New Staff Shift</h4>
      </div>
    </div>
    <div class="row text-danger bg-light" v-else>
      <p>{{ errorMessage }}</p>
    </div>
    <hr />
    <b-form>
      <div class="row">
        <div class="col-md-3">
          <b-form-group class="mb-4" label-for="password-input">
            <span class="text-dark me-2"> Date :</span>
            <date-picker
              lang="en"
              placeholder="MM-DD-YYYY"
              v-model="selectedDate"
              type="date"
              value-type="format"
            ></date-picker>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div>
          <span class="text-dark mb-2">SELECT A STAFF :</span>
          <div class="d-flex align-items-center mb-3">
            <input
              type="checkbox"
              class="form-check-input mt-0 me-1 text-dark"
              v-model="formStaffs"
              @change="addStaff('selectAllStaff')"
            />
            <label class="mb-0"> Select all staff </label>
          </div>
        </div>
        <div class="col-md-3" v-for="(staff, index) in staffs" :key="index">
          <div class="card mb-3">
            <div class="py-1 px-2">
              <div class="d-flex align-items-center">
                <input
                  :id="index"
                  type="checkbox"
                  class="form-check-input"
                  v-model="formStaffs"
                  :value="staff"
                  @change="addStaff(staff)"
                />
                <div class="ms-2" :for="index">
                  <label class="mb-0 font-size-12 text-capitalize" :for="index"
                    >{{ staff.title }} {{ staff.first_name }}
                    {{ staff.last_name }}</label
                  >
                  <span class="d-block text-dark font-size-10">{{
                    staff.role.name
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-md-12">
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            type="reset"
            @click="cancelSubmit"
            >Cancel</b-button
          >
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            type="button"
            @click="saveAndAddNew"
            :class="{ disabled: isSaveAndAddNew === true && isBtnLoading }"
          >
            <i
              v-if="isSaveAndAddNew === true && isBtnLoading"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            ></i
            >Save & Add</b-button
          >
          <b-button
            class="float-end"
            variant="outline-primary"
            type="button"
            @click="handleSubmit"
            :class="{ disabled: isSaveAndAddNew !== true && isBtnLoading }"
          >
            <i
              v-if="isSaveAndAddNew !== true && isBtnLoading"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            ></i>
            Save
          </b-button>
        </div>
      </div>
    </b-form>
  </div>
</template>
